import React, { useState, useEffect } from "react";
import { sendResult } from "../../utils/helper";

// Style
import "./LevelSeis.scss";

// Assets
import hex from "../../assets/images/level-dos/hexagon.svg";
import pointer from "../../assets/images/level-seis/pointer.svg";

// Components
import Navbar from "../../components/common/Navbar";

// consts
import { POINTER_DIV } from "../../utils/consts";
import LevelComplete from "../../components/common/LevelComplete/LevelComplete";

const LevelSeis = (props) => {
  const [pointers, setPointers] = useState(POINTER_DIV);
  const [dotPosition, setDotPosition] = useState({ x: 3, y: 3 });
  const [won, setWon] = useState(false);
  const [move, setMove] = useState(false);
  const [dataPoints, setDataPoints] = useState({
    firstMoveCircleTime: 0,
    threeSameDirTime: 0,
    threeSameDirClicks: 0,
    edgeTime: 0,
    edgeClicks: 0,
    totalTime: 0,
    totalClicks: 0,
  });

  // Clicks
  const [clicks, setClicks] = useState(0);

  // Timer
  const [timer, setTimer] = useState(0);

  // Timer increase
  useEffect(() => {
    setTimeout(() => setTimer(timer + 1), 1000);
  }, [timer]);

  useEffect(() => {
    if (
      dotPosition.x < 0 ||
      dotPosition.x > 6 ||
      dotPosition.y < 0 ||
      dotPosition.y > 6
    ) {
      setWon(true);
    }
    getDatapoints();
  }, [dotPosition]);

  // Call won state
  useEffect(() => {
    setTimeout(() => {
      if (won) {
        getDatapoints();
        const finalObj = {
          gameData: {
            levelData: [
              {
                level: 7,
                levelName: 'Emit',
                firstMoveCircleTime: dataPoints.firstMoveCircleTime,
                threeSameDirTime: dataPoints.threeSameDirTime,
                threeSameDirClicks: dataPoints.threeSameDirClicks,
                edgeTime: dataPoints.edgeTime,
                edgeClicks: dataPoints.edgeClicks,
                totalTime: timer,
                totalClicks: clicks,
                isLevelCleared: true,
                isLevelSkipped: false,
                totalHintsTaken: localStorage.getItem("totalHints"),
                timeForFirstHint: localStorage.getItem("totalHints") !== 0 ? localStorage.getItem("hint1") : 0,
                timeForSecondHint: localStorage.getItem("totalHints") !== 0 ? localStorage.getItem("hint2") : 0
              }
            ],
          }
        }
        console.log(finalObj)
        sendResult(finalObj)
        setMove(true);
      }
    }, 500);
  }, [won]);

  const getDatapoints = () => {
    let tempDataPoints = { ...dataPoints };

    // Time taken to move circle first time
    if (tempDataPoints.firstMoveCircleTime === 0) {
      tempDataPoints.firstMoveCircleTime = timer;
    }

    if (won) {
      tempDataPoints.totalClicks = clicks;
      tempDataPoints.totalTime = timer;
    }

    setDataPoints(tempDataPoints);
  };

  const moveDot = () => {
    setClicks(clicks + 1);
    let tempDotPos = { ...dotPosition };
    pointers.forEach((item, index) => {
      if (tempDotPos.x === item.x && tempDotPos.y === item.y) {
        switch (item.direction) {
          case "up":
            setDotPosition({ x: tempDotPos.x, y: tempDotPos.y - 1 });
            break;
          case "down":
            setDotPosition({ x: tempDotPos.x, y: tempDotPos.y + 1 });
            break;
          case "left":
            setDotPosition({ x: tempDotPos.x - 1, y: tempDotPos.y });
            break;
          case "right":
            setDotPosition({ x: tempDotPos.x + 1, y: tempDotPos.y });
            break;
          default:
            break;
        }
      }
    });
  };

  const rotatePointer = ({ item, index }) => {
    setClicks(clicks + 1);
    let tempPointers = [...pointers];
    switch (tempPointers[index].direction) {
      case "down":
        tempPointers[index].direction = "left";
        break;
      case "left":
        tempPointers[index].direction = "up";
        break;
      case "up":
        tempPointers[index].direction = "right";
        break;
      case "right":
        tempPointers[index].direction = "down";
        break;
      default:
        break;
    }
    setPointers(tempPointers);
  };

  const getRotation = ({ item, index }) => {
    switch (item.direction) {
      case "down":
        return "180deg";
      case "left":
        return "270deg";
      case "up":
        return "0deg";
      case "right":
        return "90deg";
      default:
        return "0deg";
    }
  };
  return (
    <div className="component-level-seis">
      {move && <LevelComplete levelNum={4} />}
      <Navbar won={won} levelNum={4} />
      <div className="game-div-seis">
        {!move && (
          <div
            className="dot"
            style={{
              top: `calc((100/7)*${dotPosition.y}%)`,
              left: `calc((100/7)*${dotPosition.x}%)`,
            }}
          >
            <img src={hex} alt="hexagon" onClick={() => moveDot()} />
          </div>
        )}
        {pointers.map((item, index) => (
          <div key={index} className="pointer-div">
            <img
              key={index}
              style={{
                transform: `rotate(${getRotation({
                  item: item,
                  index: index,
                })})`,
              }}
              onClick={() => rotatePointer({ item: item, index: index })}
              src={pointer}
              alt="pointer"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default LevelSeis;
